import { RootState } from '../../store';
import { MultiSigWallet } from '@stichting-allianceblock-foundation/multisig-contracts/typechain/MultiSigWallet';

export const getWalletContract = (state: RootState): MultiSigWallet | undefined =>
  state.ethers.contracts.wallet as MultiSigWallet;
